import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_55082072 from 'nuxt_plugin_sentryserver_55082072' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_6fc27e3f from 'nuxt_plugin_sentryclient_6fc27e3f' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_recaptcha_099d37f2 from 'nuxt_plugin_recaptcha_099d37f2' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_externalroutesclient_0f09b168 from 'nuxt_plugin_externalroutesclient_0f09b168' // Source: ./external-routes.client.js (mode: 'client')
import nuxt_plugin_alaoassistantv2client_79477e1b from 'nuxt_plugin_alaoassistantv2client_79477e1b' // Source: ./alao-assistant-v2.client.js (mode: 'client')
import nuxt_plugin_growthbookclient_28c1e550 from 'nuxt_plugin_growthbookclient_28c1e550' // Source: ./growthbook.client.js (mode: 'client')
import nuxt_plugin_i18nextended_31407bca from 'nuxt_plugin_i18nextended_31407bca' // Source: ./i18n-extended.plugin (mode: 'all')
import nuxt_plugin_dixa_7b479387 from 'nuxt_plugin_dixa_7b479387' // Source: ./dixa.js (mode: 'client')
import nuxt_plugin_facebookpixelextendedclient_467276ba from 'nuxt_plugin_facebookpixelextendedclient_467276ba' // Source: ./facebook-pixel-extended.client.js (mode: 'client')
import nuxt_plugin_googlecustomersurvey_dc312f80 from 'nuxt_plugin_googlecustomersurvey_dc312f80' // Source: ./google-customer-survey.js (mode: 'all')
import nuxt_plugin_emarsyswebextendclient_ec407e28 from 'nuxt_plugin_emarsyswebextendclient_ec407e28' // Source: ./emarsys-web-extend.client.js (mode: 'client')
import nuxt_plugin_featureflagsplugin_0db880fb from 'nuxt_plugin_featureflagsplugin_0db880fb' // Source: ./feature-flags-plugin.ts (mode: 'all')
import nuxt_plugin_portalvue_76477330 from 'nuxt_plugin_portalvue_76477330' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_vlazyload_2c3871b1 from 'nuxt_plugin_vlazyload_2c3871b1' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_vuescrollto_5e2149a6 from 'nuxt_plugin_vuescrollto_5e2149a6' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_webfontloader_684b7603 from 'nuxt_plugin_webfontloader_684b7603' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_gtm_3f38e2ce from 'nuxt_plugin_gtm_3f38e2ce' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_83e2dcd0 from 'nuxt_plugin_pluginutils_83e2dcd0' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2ab118e3 from 'nuxt_plugin_pluginrouting_2ab118e3' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_cd4b9528 from 'nuxt_plugin_pluginmain_cd4b9528' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_veevalidate_738289e8 from 'nuxt_plugin_veevalidate_738289e8' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_axios_926039fa from 'nuxt_plugin_axios_926039fa' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_7798b942 from 'nuxt_plugin_workbox_7798b942' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_3a9f1b72 from 'nuxt_plugin_metaplugin_3a9f1b72' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_3f46c0e6 from 'nuxt_plugin_iconplugin_3f46c0e6' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_deviceplugin_10bc70e4 from 'nuxt_plugin_deviceplugin_10bc70e4' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_alaouiplugin_a5194184 from 'nuxt_plugin_alaouiplugin_a5194184' // Source: ../plugins/alao-ui.plugin.ts (mode: 'all')
import nuxt_plugin_vuexpersistplugin_340265ca from 'nuxt_plugin_vuexpersistplugin_340265ca' // Source: ../plugins/vuex-persist.plugin.ts (mode: 'all')
import nuxt_plugin_index_e8a850ec from 'nuxt_plugin_index_e8a850ec' // Source: ../plugins/axios/index.ts (mode: 'all')
import nuxt_plugin_mqplugin_49cb4c74 from 'nuxt_plugin_mqplugin_49cb4c74' // Source: ../plugins/mq.plugin.ts (mode: 'all')
import nuxt_plugin_index_4f5ffcb5 from 'nuxt_plugin_index_4f5ffcb5' // Source: ../node_modules/@alao-frontend/analytics.plugin/index.ts (mode: 'client')
import nuxt_plugin_index_6c2e71ad from 'nuxt_plugin_index_6c2e71ad' // Source: ../node_modules/@alao-frontend/vue-observe-visibility.plugin/index.ts (mode: 'client')
import nuxt_plugin_index_57161199 from 'nuxt_plugin_index_57161199' // Source: ../node_modules/@alao-frontend/client-global-error-handlers.plugin/index.ts (mode: 'client')
import nuxt_plugin_index_d4736008 from 'nuxt_plugin_index_d4736008' // Source: ../node_modules/@alao-frontend/console-stamp.plugin/index.ts (mode: 'server')
import nuxt_plugin_index_6b828574 from 'nuxt_plugin_index_6b828574' // Source: ../node_modules/@alao-frontend/global-filters.plugin/index.ts (mode: 'all')
import nuxt_plugin_index_acf875d0 from 'nuxt_plugin_index_acf875d0' // Source: ../node_modules/@alao-frontend/validator-extend.plugin/index.ts (mode: 'all')
import nuxt_plugin_index_55acb010 from 'nuxt_plugin_index_55acb010' // Source: ../node_modules/@alao-frontend/v-click-outside.plugin/index.ts (mode: 'all')
import nuxt_plugin_index_884856ca from 'nuxt_plugin_index_884856ca' // Source: ../node_modules/@alao-frontend/nuxt-device-custom-flags.plugin/index.ts (mode: 'all')
import nuxt_plugin_index_0f674641 from 'nuxt_plugin_index_0f674641' // Source: ../node_modules/@alao-frontend/i18n.plugin/index.ts (mode: 'all')
import nuxt_plugin_plugin_67b28046 from 'nuxt_plugin_plugin_67b28046' // Source: ../node_modules/@alao-frontend/nuxt-axios-cache/plugin.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"alao","titleTemplate":(titleChunk) => `${titleChunk} | alao`,"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0","user-scalable":"0"},{"hid":"description","name":"description","content":""},{"hid":"google-site-verification-1","name":"google-site-verification","content":"GXa4JqJRi1W-rTyjO1Zm71og2HcEcBDVjQKYCOzZe88"},{"hid":"google-site-verification-2","name":"google-site-verification","content":"KFrk07FwIZ2-aCXWN4R7nBsPOMrpcYGbQj9YD-6j734"},{"hid":"google-site-verification-merchant-center","name":"google-site-verification","content":"6io-XPrmNQL6s2BNcU1oy2efiTjwtCszjJqC3_YjNy8"},{"hid":"facebook-domain-verification","name":"facebook-domain-verification","content":"r47hmzncn8g6q95xt5z5ytq2mt5b53"}],"script":[{"src":"\u002F\u002Fwww.googleoptimize.com\u002Foptimize.js?id=GTM-5J7SZ66","async":false,"body":false,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KCSQKCW')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"script":["data-layer-definition"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fd16jaymuycdk0d.cloudfront.net\u002F66ab70c0","crossorigin":"anonymous"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KCSQKCW&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_55082072 === 'function') {
    await nuxt_plugin_sentryserver_55082072(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_6fc27e3f === 'function') {
    await nuxt_plugin_sentryclient_6fc27e3f(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_099d37f2 === 'function') {
    await nuxt_plugin_recaptcha_099d37f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_externalroutesclient_0f09b168 === 'function') {
    await nuxt_plugin_externalroutesclient_0f09b168(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_alaoassistantv2client_79477e1b === 'function') {
    await nuxt_plugin_alaoassistantv2client_79477e1b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_growthbookclient_28c1e550 === 'function') {
    await nuxt_plugin_growthbookclient_28c1e550(app.context, inject)
  }

  if (typeof nuxt_plugin_i18nextended_31407bca === 'function') {
    await nuxt_plugin_i18nextended_31407bca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dixa_7b479387 === 'function') {
    await nuxt_plugin_dixa_7b479387(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebookpixelextendedclient_467276ba === 'function') {
    await nuxt_plugin_facebookpixelextendedclient_467276ba(app.context, inject)
  }

  if (typeof nuxt_plugin_googlecustomersurvey_dc312f80 === 'function') {
    await nuxt_plugin_googlecustomersurvey_dc312f80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_emarsyswebextendclient_ec407e28 === 'function') {
    await nuxt_plugin_emarsyswebextendclient_ec407e28(app.context, inject)
  }

  if (typeof nuxt_plugin_featureflagsplugin_0db880fb === 'function') {
    await nuxt_plugin_featureflagsplugin_0db880fb(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_76477330 === 'function') {
    await nuxt_plugin_portalvue_76477330(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_2c3871b1 === 'function') {
    await nuxt_plugin_vlazyload_2c3871b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_5e2149a6 === 'function') {
    await nuxt_plugin_vuescrollto_5e2149a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_684b7603 === 'function') {
    await nuxt_plugin_webfontloader_684b7603(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_3f38e2ce === 'function') {
    await nuxt_plugin_gtm_3f38e2ce(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_83e2dcd0 === 'function') {
    await nuxt_plugin_pluginutils_83e2dcd0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2ab118e3 === 'function') {
    await nuxt_plugin_pluginrouting_2ab118e3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_cd4b9528 === 'function') {
    await nuxt_plugin_pluginmain_cd4b9528(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_738289e8 === 'function') {
    await nuxt_plugin_veevalidate_738289e8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_926039fa === 'function') {
    await nuxt_plugin_axios_926039fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7798b942 === 'function') {
    await nuxt_plugin_workbox_7798b942(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_3a9f1b72 === 'function') {
    await nuxt_plugin_metaplugin_3a9f1b72(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_3f46c0e6 === 'function') {
    await nuxt_plugin_iconplugin_3f46c0e6(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_10bc70e4 === 'function') {
    await nuxt_plugin_deviceplugin_10bc70e4(app.context, inject)
  }

  if (typeof nuxt_plugin_alaouiplugin_a5194184 === 'function') {
    await nuxt_plugin_alaouiplugin_a5194184(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexpersistplugin_340265ca === 'function') {
    await nuxt_plugin_vuexpersistplugin_340265ca(app.context, inject)
  }

  if (typeof nuxt_plugin_index_e8a850ec === 'function') {
    await nuxt_plugin_index_e8a850ec(app.context, inject)
  }

  if (typeof nuxt_plugin_mqplugin_49cb4c74 === 'function') {
    await nuxt_plugin_mqplugin_49cb4c74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_4f5ffcb5 === 'function') {
    await nuxt_plugin_index_4f5ffcb5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_6c2e71ad === 'function') {
    await nuxt_plugin_index_6c2e71ad(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_57161199 === 'function') {
    await nuxt_plugin_index_57161199(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_index_d4736008 === 'function') {
    await nuxt_plugin_index_d4736008(app.context, inject)
  }

  if (typeof nuxt_plugin_index_6b828574 === 'function') {
    await nuxt_plugin_index_6b828574(app.context, inject)
  }

  if (typeof nuxt_plugin_index_acf875d0 === 'function') {
    await nuxt_plugin_index_acf875d0(app.context, inject)
  }

  if (typeof nuxt_plugin_index_55acb010 === 'function') {
    await nuxt_plugin_index_55acb010(app.context, inject)
  }

  if (typeof nuxt_plugin_index_884856ca === 'function') {
    await nuxt_plugin_index_884856ca(app.context, inject)
  }

  if (typeof nuxt_plugin_index_0f674641 === 'function') {
    await nuxt_plugin_index_0f674641(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_67b28046 === 'function') {
    await nuxt_plugin_plugin_67b28046(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
